import React, { useContext, useEffect, useState, useRef } from "react";
import { graphql, navigate, useStaticQuery } from "gatsby";
import { CircularProgress } from "@mui/material";
import GlobalContext from "../../../contexts/globalContext";
import rawToReact from "../../../utils/rawToReact";
import useBrowserMode from '../../../shared/hooks/useBrowserMode';
import contentfulRenderOptions from "../../../utils/contentfulRenderOption";
import moment from "moment";

// Components //
import Modal from "../../ui/modal/Modal";
import Button from "../../atoms/button/button";
import FormHead from "../../molecules/form-head/FormHead";
import FormBody from "../../molecules/form-body/FormBody";
import ErrorModal from "../../ui/modal/Modal";

// Services //
import getSchedulingMentoria from "../../../services/mentoriaSiseService";
import { getMunicipalities, getAllDepartments } from "../../../services/municipalities";
import { saveForm, getToken, getUserFormDataByQuestionId } from "../../../services/formServices";

// Helpers //
import { isDateMoreThanXMonthsAgo } from "../../../utils/helpers";

// Styles //
import "./FormTallerAprendizajeRegiones.scss";
import iconLila from "../../../assets/images/icons/icon-lilac.svg"
import { FormTallerAprendizajeRegionesQuery } from "./queryContentful/FormTallerAprendizajeRegionesQuery";

const FormTallerAprendizajeRegiones = (props: any) =>{

    const data = FormTallerAprendizajeRegionesQuery();
    let listCityAmva = [
        "Medellin",
        "Barbosa",
        "Bello",
        "Caldas",
        "Copacabana",
        "Envigado",
        "Girardota",
        "Itagui",
        "La Ceja",
        "La Estrella",
        "El Retiro",
        "Rionegro",
        "Sabaneta",
    ];

    const listEducationLevelsFormationArea = [
        "Técnico",
        "Tecnólogo",
        "Universitario",
        "Especialista",
        "Maestría",
    ];

    interface IModalContent {
        title: string;
        image: string;
        textButton: string;
        url: string;
        textOptionalButton: string;
        urlOptional: string;
    }

    const contentfulData = data.form.nodes[0];
    const contentfulModalSuccess = data.modalSuccess.nodes[0];
    const contentfulModalWithoutAge = data.modalWithoutAge.nodes[0];
    const modalSuccessVacantes = data.modalSuccessVacantes.nodes[0];
    const modalSuccessTallerCursos = data.modalSuccessTallerCursos.nodes[0];
    const pantallaSinInteresConEmpleo = data.pantallaSinInteresConEmpleo.nodes[0];
    const pantallaConInteresConEmpleo = data.pantallaConInteresConEmpleo.nodes[0];
    const pantallaSinInteresSinEmpleo = data.pantallaSinInteresSinEmpleo.nodes[0];
    const pantallaRegistroDuplicado = data.pantallaRegistroDuplicado.nodes[0];
    const dataTableTalleres = JSON.parse(contentfulData.titulosFormulario[5].referenciaFormulario[3].textoTerminosMigrantes.raw);
    const Context = useContext(GlobalContext);
    const posRef = useRef<HTMLDivElement>(null);
    const { isBrowser, window } = useBrowserMode();
    const [modalContent, setModalContent] = useState<IModalContent>();

    const defaultFormValues = {};
    const fieldsToSkipAux:string[] = [];

    const [formValues, setFormValues] = useState<any>(defaultFormValues);
    const [municipality, setMunicipality] = useState("");
    const [departments, setDepartments] = useState([]);
    const [docNumber, setDocNumber] = useState("");
    const [loadingMentoriaAPI, setLoadingMentoriaAPI] = useState(false);
    const [continueFormMentoriaValidation, setContinueFormMentoriaValidation] = useState(true);
    const [continueCourses, setCountinueCourses] = useState(false);
    const [continueVacancies, setCountinueVacancies] = useState(false);
    const [isDisabledButton, setDisabledButton] = useState<boolean>(false);
    const [inputDisabled, setInputDisabled] = useState<string[]>([]);
    const [fieldsToSkip, setFieldsToSkip]= useState<string[]>([]);
    const [selectedDay, setSelectedDay] = useState(null);
    const [documentType, setDocumentType] = useState("");
    const [hasFormalEmploy, setHasFormalEmploy] = useState<boolean>();
    const [workShop, setWorkShop] = useState(null);
    const [showModalVacancies, setShowModalVacancies] = useState(false);
    const [showModalCourses, setShowModalCourses] = useState(false);
    const [showModalCourses2, setShowModalCourses2] = useState(false);
    const [showModalAlreadyInBoth, setShowModalAlreadyInBoth] = useState(false);
    const [hasDisability, setHasDisability] = useState("");
    const [disability, setDisability] = useState("");
    const [interested_workshop, setInterestedWorkshop] = useState("");
    const [talleresData, setTalleresData] = useState(null);
    const [selectedModality, setSelectedModality] = useState("");
    const [duration, setDuration] = useState("");
    const [cancelForm, setCancelForm] = useState(false);
    const [selectedReason, setSelectedReason] = useState("");
    const hiddenFields = {["inscrito_mentoria"]: "", ["asistencia_mentoria"]: "", ["fecha_mentoria"]: "", ["mentor"]: "", ["contributionFee"]: ""};
    const [showConInteresConEmpleo, setShowConInteresConEmpleo] = useState(false);
    const [showSinInteresSinEmpleo, setShowSinInteresSinEmpleo] = useState(false);
    const [contentfulDataHelper, setContentfulDataHelper] = useState(contentfulData);
    const [validBirthDate, setValidBirthDate] = useState(false);
    const [showModalWithoutAge, setShowModalWithoutAge] = useState<boolean>(false);
    const [dateStateHelper, setDateStateHelper] = useState<boolean>(false);

    // funcion para encontrar un texto en un nodo especifico (lista de talleres)
    const containsMentoresText = (obj: any) => {
        if (obj.nodeType === 'text' && obj.value.includes('mentores')) {
            return true;
        }

        if (Array.isArray(obj)) {
            return obj.some(containsMentoresText);
        } else if (typeof obj === 'object' && obj !== null) {
            return Object.values(obj).some(containsMentoresText);
        }

        return false;
    }

    //funcion para remover Nodo padre (lista de talleres)
    const removeParentWithMentoresText = (obj:any) => {
        if (Array.isArray(obj)) {
            return obj
            .map(removeParentWithMentoresText)
                .filter(item => item !== null);
            } else if (typeof obj === 'object' && obj !== null) {
            if (obj.nodeType === 'table-row' && containsMentoresText(obj)) {
                return null; // Solo retorna null si es un nodo table-row con texto "mentores"
            }

            // Procesa recursivamente los hijos del nodo
            for (let key in obj) {
                if (obj.hasOwnProperty(key)) {
                    const result = removeParentWithMentoresText(obj[key]);
                    if (result !== null) {
                        obj[key] = result;
                    } else {
                        delete obj[key]; // Elimina la propiedad si el resultado es null
                    }
                }
            }
        }
        return obj;
    }

    const setDurationState = (value: string) =>{
        setDuration(value);
    }

    let selectorStatusFormationArea: any = null;
    let selectorFormDisability: any = null;
    let selectorFormDescriptionDisability: any = null;
    let selectorEducationLevel: any = null;
    let selectorTallerTable: any = null;
    let selectorReasonNotInterested: any = null;
    let selectorAnotherReason: any = null;

    //Validaciones para los inputs
    const inputRegexValidation = (field: any, value: any) => {
        // Evita que el usuario incluya caracteres no alfabeticos
        if (field === "nameContact" || field === "role") {
            const re = /^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g;
            return re.test(value);
        } else if (field === "phone" || field === "aux_number") {
            return value.length <= 10 ? true : false;
        }
        return true;
    };
    const registerDate = moment(Date.now()).format("DD-MM-YYYY");
    const pathName = isBrowser ? window.location.pathname : '';
    const isTalleresRegionesMentor = pathName.includes("talleres-regiones-mentor");

    useEffect(() => {
        const observer = new MutationObserver(() => {
            const atentionTeamElement = document.querySelector(".a-input__form-atentionTeam");
            if (atentionTeamElement) {
                if (!isTalleresRegionesMentor) {
                    // Ocultar el elemento
                    (atentionTeamElement as HTMLElement).style.display = "none";

                    // Añadir el campo "atentionTeam" a fieldsToSkip
                    setFieldsToSkip((prevFields) => {
                        if (!prevFields.includes("atentionTeam")) {
                            return [...prevFields, "atentionTeam"];
                        }
                        return prevFields;
                    });
                } else {
                    // Mostrar el elemento
                    (atentionTeamElement as HTMLElement).style.display = "block";

                    // Remover el campo "atentionTeam" de fieldsToSkip
                    setFieldsToSkip((prevFields) =>
                        prevFields.filter((field) => field !== "atentionTeam")
                    );
                }
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });

        return () => observer.disconnect();
    }, [isTalleresRegionesMentor, setFieldsToSkip]);

    useEffect(() => {
        selectorStatusFormationArea = document.querySelector(".a-input__form-formation_area");
        selectorFormDisability = document.querySelector(".a-input__form-disability");
        selectorFormDescriptionDisability = document.querySelector(".a-input__form-description_disability");
        selectorTallerTable = document.querySelector(".a-input__form-table-select");
        selectorEducationLevel = document.getElementById("select_education_level");
        selectorReasonNotInterested = document.querySelector(".a-input__form-reason_not_interested");
        selectorAnotherReason = document.querySelector(".a-input__form-another_reason");
    }, [formValues, talleresData])


    // servicio para consultar los registros de usuario en nuestra DB
    const getAnswersByDocNumber = async (idForm: number) => {
        const token = await getToken(Context?.gigyaContext?.gigyaAccount?.UID);
        const dataAnswers = await getUserFormDataByQuestionId(token, idForm, "docNumber", formValues.docNumber );
        return dataAnswers;
    };

    const changeDisplayElement = (selector: string, displayType: string) => {
        document.querySelector(selector).style.display = displayType;
    };

    const resetFormValues = (key: string, selector: string) => {
        setFormValues((prev:any) => {
            const auxFormValues = { ...prev };
            delete auxFormValues[key];
            return auxFormValues;
        });
        const inputSel = document.querySelector(selector) as HTMLInputElement | null;
        if (inputSel) {
            inputSel.value = "";
        }
    };

    const updateInputValue = (field: string, value: any, type?: string) => {

        const selectorReasonNotInterested : any = document.querySelector(".a-input__form-reason_not_interested");
        const selectorAnotherReason : any = document.querySelector(".a-input__form-another_reason");

        setFormValues({ ...formValues, ...hiddenFields});
        if (inputRegexValidation(field, value)) {
            setFormValues((prev: any) => {
                return { ...prev, [field]: value };
            });
        }

        if (field == "municipalities"){
            setMunicipality(value);
            // setInputDisabled(["municipalities"]);
            localStorage.setItem("municipality", value);
        }

        if (field == "deparment") {
            departments.find((department: any) => {
                if (department.name === value) {
                    municipalitiesList(department.id);
                }
            });
        }

        if (field == "municipality_of_residence"){
            setMunicipality(value);
        }

        if (field == "docNumber"){
            setDocNumber(value);
            localStorage.setItem("docNumber", value);
        }

        if (field == "documentType"){
            const docValues = {
                'Cédula de ciudadanía': 'CC',
                'Cédula de extranjería':'CE',
                'Tarjeta de identidad':'TI',
                'Pasaporte':'PA',
                'Permiso especial de permanencia':'PEP',
                'Documento nacional de identificación':'DNI'
            }
            setDocumentType(docValues[value]);
        }

        const fieldsGeneralData = ["aux_number", "birth_date", "cellphone", "email", "gender"];

        if (fieldsGeneralData.includes(field) && formValues.education_level) {
            fieldsToSkipAux.push("formation_area");
        }

        if(field == "education_level"){
            if(selectorStatusFormationArea != undefined){
                if (!listEducationLevelsFormationArea.includes(selectorEducationLevel.value)){
                    selectorStatusFormationArea.style.visibility = 'hidden';
                    selectorStatusFormationArea.style.height = '0';
                    selectorStatusFormationArea.style.margin = '0';
                    fieldsToSkipAux.push("formation_area");
                } else {
                    selectorStatusFormationArea.style.visibility = 'visible';
                    selectorStatusFormationArea.style.height = 'auto';
                }
            }else{
                fieldsToSkipAux.push("formation_area");
            }
        }

        // Tienes alguna discapacidad??
        if (field =="has_disability"){
            setHasDisability("No");

            if(value === "No") {
                selectorFormDisability.style.display = "none";
                selectorFormDescriptionDisability.style.display = "none";
                fieldsToSkipAux.push("disability");
                fieldsToSkipAux.push("description_disability");
                setHasDisability("No");
            } else {
                selectorFormDisability.style.display = "flex";
                selectorFormDescriptionDisability.style.display = "none";
                setHasDisability("Si");
            }
        }

        if (field == "disability") {
            setDisability(value);
            selectorFormDescriptionDisability.style.display = "flex";

            if (value === "Física") {
                setHasDisability("No");
                fieldsToSkipAux.push("disability");
            } else {
                setHasDisability("Si");
            }
        }

        if (field == "formal_employee") {
            setDisabledButton(true);
            setLoadingMentoriaAPI(true);
            if (value == "Sí"){
                setHasFormalEmploy(true);
                getAnswersByDocNumber(16).then((answer) => {
                    if (answer.data.answerData != null || isDateMoreThanXMonthsAgo(answer.data.creationDate, contentfulData.timeValidation || 3) == false) {
                        setLoadingMentoriaAPI(false);
                        setShowModalAlreadyInBoth(true);
                        setCountinueVacancies(true);
                    } else {
                        setDisabledButton(false);
                        setLoadingMentoriaAPI(false);
                    }
                });
            } else {
                setHasFormalEmploy(false);
                getAnswersByDocNumber(16).then((answer) => {
                    if (answer.data.answerData != null || isDateMoreThanXMonthsAgo(answer.data.creationDate, contentfulData.timeValidation || 3) == false) {
                        getAnswersByDocNumber(17).then((answer) => {
                            if (answer.data.answerData != null || isDateMoreThanXMonthsAgo(answer.data.creationDate, contentfulData.timeValidation || 3) == false) {
                                setShowModalAlreadyInBoth(true);
                                setLoadingMentoriaAPI(false)
                            } else {
                                redirectToCourses();
                            }
                        })

                    } else {
                        setDisabledButton(false);
                        setLoadingMentoriaAPI(false)
                    }
                });
            }
        }

        // ¿Estás interesado en participar en la oferta de talleres?
        if (field =="interested_workshop") {
            setInterestedWorkshop(value);

            if (value === "Si"){
                selectorReasonNotInterested.style.display = "none";
                formValues.reason_not_interested = " ";

                selectorAnotherReason.style.display = "none";
                formValues.another_reason = " ";

                fieldsToSkipAux.push("reason_not_interested");
                fieldsToSkipAux.push("another_reason");

                selectorTallerTable.style.display = "flex";
                const urlRegion = window.location.href.includes("talleres-regiones/");
                if (urlRegion){
                    setTalleresData(removeParentWithMentoresText(dataTableTalleres));
                } else {
                    setTalleresData(dataTableTalleres);
                }

            } else {
                setTalleresData(null);
                selectorTallerTable.style.display = "none";
                selectorReasonNotInterested.style.display = "flex";
                fieldsToSkipAux.push("workshop_offer");
            }
        }

        if (field == "reason_not_interested") {
            fieldsToSkipAux.push("workshop_offer");
            setSelectedReason(value);
            formValues.another_reason = " ";

            if (value == "Otra") {
                selectorAnotherReason.style.display = "flex";

                if (document.getElementById("text-area-another_reason").value === "") {
                    setDisabledButton(true);
                }
            } else {
                selectorAnotherReason.style.display = "none";
                document.getElementById("text-area-another_reason").value = "";

                fieldsToSkipAux.push("another_reason");
                setDisabledButton(false)
            }
        }

        if (field == "another_reason") {
            fieldsToSkipAux.push("workshop_offer");
            setDisabledButton(false);
        }


        if (field == "workshop_offer") {
            setSelectedReason(" ");
            formValues.reason_not_interested = selectedReason;
            fieldsToSkipAux.push("reason_not_interested");
            fieldsToSkipAux.push("another_reason");
            value.split(' - ')[1] ?  setSelectedModality(value.split(' - ')[1]) : setSelectedModality(value.split(' ').pop().toLowerCase());
            setWorkShop(value);
        }

        if (field == "location_zone"){
            if(value === "Rural") {
                changeDisplayElement(".a-input__form-ruralDistrict", "block");
                changeDisplayElement(".a-input__form-movementType", "block");
            } else {
                changeDisplayElement(".a-input__form-ruralDistrict", "none");
                resetFormValues("ruralDistrict", "#input-ruralDistrict");
                changeDisplayElement(".a-input__form-movementType", "none");
                resetFormValues("movementType", "#input-movementType");
                fieldsToSkipAux.push("ruralDistrict");
                fieldsToSkipAux.push("movementType");
            }
        }

        if (field === "atentionTeam" && !isTalleresRegionesMentor) {
            fieldsToSkipAux.push("atentionTeam");
        }

        setFieldsToSkip(fieldsToSkipAux);
    };

    useEffect(() => {
        selectorReasonNotInterested = document.querySelector(".a-input__form-reason_not_interested");
        selectorAnotherReason = document.querySelector(".a-input__form-another_reason");

        if (selectedReason === "Otra") {
            setDisabledButton(true);
        } else if (selectedReason === " ") {
            formValues.reason_not_interested = selectedReason;
            formValues.another_reason = " ";
        } else {
            formValues.another_reason = " ";
            setDisabledButton(false);
        }

    }, [selectedReason]);

    useEffect(() => {
        changeDisplayElement(".a-input__form-ruralDistrict", "none");
        changeDisplayElement(".a-input__form-movementType", "none");
    }, []);

    const createPayload = () => {
        let payload: any = {
            idForm: 16,
            answers: [],
        };

        if (formValues.deparment) {
            const municipalityFullName = `${formValues.municipalities} - ${formValues.deparment}`;

            formValues.municipalities = municipalityFullName;
            formValues.municipality_of_residence = municipalityFullName;

            delete formValues.deparment;
        }

        // Delete key/values skipped from formValues
        fieldsToSkip.forEach(field => delete formValues[field]);

        Object.entries(formValues).forEach(([key, value]) => {
            payload.answers.push({ contentfulId: key, answer: value });
        });
        return payload;
    };


    const handleSubmitForm = async () => {
        setDisabledButton(true);
        const payload = createPayload();
        const token = await getToken(null);
        const response = await saveForm(payload, token);
        setDisabledButton(false);
        handleModalContent(response.data.status);
    };

    const matchDocumentType = (docType: string) => {
        switch (docType) {
            case "CC":
                return "Cédula de ciudadanía";
            default:
                return "";
        }
    }

    const matchGender = (gender: string) => {
        switch (gender) {
            case "M":
                return "Hombre";
            case "F":
                return "Mujer";
            default:
                return "";
        }
    }

    const handleCancel = () =>{
        setCancelForm(true);
    }

    const handleClickNext = async () => {
        window.scrollTo(0, 0);
        if(municipality != ""){

            if(isTalleresRegionesMentor) {
                listCityAmva = listCityAmva.filter(city => !["La Ceja", "Rionegro", "El Retiro"].includes(city));
            }

            if(listCityAmva.includes(municipality)){
                redirectToAMVA();
            }
            
            setMunicipality(municipality);
            setFormValues({
                ...formValues,
                municipality_of_residence: municipality
            });
        }

        if(docNumber != "" && !isTalleresRegionesMentor){
            setLoadingMentoriaAPI(true);
            const responseJson = await getSchedulingMentoria(docNumber,documentType);

            if (responseJson.data.status == 200) {
                const dataSorted = responseJson.data.data.sort((a, b) => {
                    return new Date(b.schedulingDate).getTime() - new Date(a.schedulingDate).getTime();
                });
            
                const dateMentoria = new Date(dataSorted[0].schedulingDate);
                const today = new Date();
                today.setFullYear(today.getFullYear() - 3); // hace 3 años
            
                if (dateMentoria.getTime() > today.getTime()) {
                    setLoadingMentoriaAPI(false);
                    const secondName = dataSorted[0].secondName ?? "";
            
                    setFormValues({
                        ...formValues,
                        documentType: matchDocumentType(dataSorted[0].documentType),
                        docNumber: dataSorted[0].docNumber,
                        complete_name : dataSorted[0].firstName +" "+ secondName +" "+ dataSorted[0].lastName + " "+ dataSorted[0].secondLastName,
                        document_type: matchDocumentType(dataSorted[0].documentType),
                        email: dataSorted[0].email,
                        gender: matchGender(dataSorted[0].gender),
                        doc_number: dataSorted[0].docNumber,
                    });
            
                    setInputDisabled(["documentType", "doc_number", "complete_name", "document_type", "municipality_of_residence"]);
                    setDocNumber("");
                } else {
                    setLoadingMentoriaAPI(false);
                    setContinueFormMentoriaValidation(false);
                }
            }else{
                setLoadingMentoriaAPI(false);
                setContinueFormMentoriaValidation(false);
            }
        // Carga registros de la DB-MentoriaTalento solo aplica para operación
        } else if (docNumber != "" && isTalleresRegionesMentor){
            setLoadingMentoriaAPI(true);
            getAnswersByDocNumber(3).then((answer) => {
                if (answer.data.answerData != null) {
                    const dataMentoriaEmpleo = answer.data.answerData;
                    setLoadingMentoriaAPI(false);
                    setFormValues({
                        ...formValues,
                        complete_name : dataMentoriaEmpleo.fullName,
                        email: dataMentoriaEmpleo.email,
                        gender: dataMentoriaEmpleo.gender,
                        document_type: dataMentoriaEmpleo.documentType,
                        doc_number: dataMentoriaEmpleo.docNumber,
                    });
                    setInputDisabled(["documentType", "doc_number", "complete_name"]);
                } else {
                    setLoadingMentoriaAPI(false);
                    setFormValues({
                        ...formValues,
                        document_type: formValues.documentType,
                        doc_number: formValues.docNumber,
                    });
                    setContinueFormMentoriaValidation(true);
                }
            });
        }

        if (hasFormalEmploy !== undefined){
            if (interested_workshop === "No" && hasFormalEmploy === true){
                setShowModalVacancies(true);
            } else {
                setShowModalCourses(false);
            }
        }


        if (hasFormalEmploy === false && workShop !== null) {
            setShowModalCourses2(true);
            setCountinueCourses(true);
        }

        if (isBrowser) {
            window.scrollTo({
                top: 100,
                behavior: "smooth",
            });
        }
    }

    const departmentsList = async () => {
        try {
            const departmentsResp = await getAllDepartments();
            setDepartments(departmentsResp.data.data);

            const departments = [];

            Object.entries(departmentsResp.data.data).forEach(
                ([key, value]) => {
                    departments.push(value.name);
                }
            );

            Object.entries(
                contentfulDataHelper.titulosFormulario[0].referenciaFormulario
            ).forEach(([key, value]) => {
                if (value.nombreId === "deparment") {
                    contentfulDataHelper.titulosFormulario[0].referenciaFormulario[
                        key
                    ].listaSelect = departments;
                }
            });
        } catch (error) {
            console.log("API Error:", error);
        }
    };    

    const municipalitiesList = async (departmentId: number) => {
        try {
            const municipalitiesResp = await getMunicipalities(departmentId);
            const municipalities = Object.values(
                municipalitiesResp.data.data
            ).map((mun) => mun.name);

            setContentfulDataHelper((prevData) => {
                const newData = { ...prevData };

                const updateSelectList = (
                    formIndex: number,
                    fieldId: string
                ) => {
                    const referenciaFormulario =
                        newData.titulosFormulario[formIndex]
                            .referenciaFormulario;
                    const field = Object.values(referenciaFormulario).find(
                        (value) => value.nombreId === fieldId
                    );
                    if (field) {
                        field.listaSelect = municipalities;
                    }
                };

                updateSelectList(0, "municipalities");
                updateSelectList(3, "municipality_of_residence");

                return newData;
            });
        } catch (error) {
            console.error("API Error:", error);
        }
    };

    useEffect(() => {
        setFormValues({ ...formValues, ["registerDate"]: registerDate });
        departmentsList();
    }, []);

    const closeForm = () => {
        navigate(`https://www.comfama.com/trabajo-con-proposito/empleo/aprendizaje-y-desarrollo/`);
    };

    const closeCancelForm = () => {
        setCancelForm(false);
    };

    const redirectToCourses = () => {
        if (!isTalleresRegionesMentor){
            navigate(props.location.href.replace("/aprendizaje/formulario/talleres-regiones/", "/aprendizaje/formulario/cursos-regiones/"));
        } else {
            navigate(props.location.href.replace("/aprendizaje/formulario/talleres-regiones-mentor/", "/aprendizaje/formulario/cursos-regiones/"));
        }
    };

    const redirectToAMVA = () => {
        if (!isTalleresRegionesMentor){
            navigate(props.location.href.replace("/aprendizaje/formulario/talleres-regiones/", "/aprendizaje/formulario/talleres/"));
        } else {
            navigate(props.location.href.replace("/aprendizaje/formulario/talleres-regiones-mentor/", "/aprendizaje/formulario/talleres-mentor/"));
        }
    };


    const closeFormMentoria = () => {
        navigate("https://www.comfama.com/servicio-de-empleo/personas/mentoria-de-talento/");
    };

    // Guarda en un estado con el contenido de los modales que se renderizan al finalizar el formulario
    const handleModalContent = (status: number) => {
        if (status === 200) {
            if (formValues.formal_employee == "Sí" && formValues.interested_workshop == "No"){
                setModalContent({
                    title: pantallaSinInteresConEmpleo.tituloPrincipal,
                    image: pantallaSinInteresConEmpleo.imagenFormulario.file.url,
                    textButton: pantallaSinInteresConEmpleo.tituloBoton,
                    url: pantallaSinInteresConEmpleo.redireccionBoton,
                    textOptionalButton: pantallaSinInteresConEmpleo.tituloBotonOpcional,
                    urlOptional: pantallaSinInteresConEmpleo.redireccionBotonOpcional,
                });
                // setShowSinInteresConEmpleo(true);
            }
            if (formValues.formal_employee == "No" && formValues.interested_workshop == "No"){
                setModalContent({
                    title: pantallaSinInteresSinEmpleo.tituloPrincipal,
                    image: pantallaSinInteresSinEmpleo.imagenFormulario.file.url,
                    textButton: pantallaSinInteresSinEmpleo.tituloBoton,
                    url: pantallaSinInteresSinEmpleo.redireccionBoton,
                    textOptionalButton: pantallaSinInteresSinEmpleo.tituloBotonOpcional,
                    urlOptional: pantallaSinInteresSinEmpleo.redireccionBotonOpcional,
                });
                setShowSinInteresSinEmpleo(true);
            }
            if (formValues.formal_employee == "Sí" && formValues.interested_workshop == "Si"){
                setModalContent({
                    title: pantallaConInteresConEmpleo.tituloPrincipal,
                    image: pantallaConInteresConEmpleo.imagenFormulario.file.url,
                    textButton: pantallaConInteresConEmpleo.tituloBoton,
                    url: pantallaConInteresConEmpleo.redireccionBoton,
                    textOptionalButton: pantallaConInteresConEmpleo.tituloBotonOpcional,
                    urlOptional: pantallaConInteresConEmpleo.redireccionBotonOpcional,
                });
                setShowConInteresConEmpleo(true);
            }
        }
    };

    useEffect(() => {
        if (formValues.birth_date) {
            let yearDiff = new Date().getUTCFullYear() - Number(formValues.birth_date.split('-')[2]);

            if ( yearDiff >= 16 ) {
                setValidBirthDate(true);
            } else {
                setShowModalWithoutAge(true);
                setValidBirthDate(false);
                // Importante: primero limpiamos el valor en formValues
                setFormValues(prev => {
                    // Creamos un nuevo objeto sin mutar el original
                    const newValues = {...prev};
                    newValues.birth_date = null;
                    return newValues;
                });
                
                // Luego activamos el helper para que el DatePicker se entere
                setDateStateHelper(true);
            }
        }
    }, [formValues.birth_date]);

    return (
        <div className="m-section-form-datosPersonales-taller-aprendizaje-regiones" ref={posRef}>
            { continueFormMentoriaValidation && !continueCourses && !continueVacancies &&
                !showModalAlreadyInBoth && !showModalVacancies && !showSinInteresSinEmpleo && !showConInteresConEmpleo && (
                <>
                    <FormHead
                        tituloPrincipal={contentfulDataHelper.tituloPrincipal}
                        descripcion={contentfulDataHelper.descripcion}
                        tituloFormulario={
                            contentfulDataHelper.tituloFormulario
                        }
                        descripcionFormulario={
                            contentfulDataHelper.descripcionFormulario.json
                        }
                    ></FormHead>
                    <FormBody
                        // Campos y estilos del formulario
                        titulosFormulario={
                            contentfulDataHelper.titulosFormulario
                        }
                        genericClassNameForm={contentfulDataHelper.metaTitulo}
                        setInputValue={updateInputValue}
                        formValues={formValues}
                        handleSubmitForm={handleSubmitForm}
                        inputDisabled={inputDisabled}
                        isDisabledButton={isDisabledButton}
                        handleEvent={handleClickNext}
                        dateState={selectedDay}
                        fieldsToSkip={fieldsToSkip}
                        talleresData={talleresData}
                        setDuration={setDurationState}
                        validBirthDate={validBirthDate}
                        dateStateHelper={dateStateHelper}
                        setDateStateHelper={setDateStateHelper}
                    >
                    <button
                        className={`btn-cancelar`}
                        onClick={() => handleCancel()}
                        >
                        Cancelar
                    </button>
                    {loadingMentoriaAPI && (
                        <div className="loader-form">
                            <span>Validando información, espere por favor...</span>
                            <CircularProgress size={100} thickness={6} color="secondary" className="loader-form-circle"/>
                        </div>
                    )}
                    {cancelForm && (
                        <Modal
                            showModal={cancelForm}
                            onClose={closeCancelForm}>
                                <div
                                    className={`m-modal-container-validation`}
                                >
                                    <h3>¿Estas seguro que quieres cancelar el proceso de inscripción?</h3>
                                    <div className="a-button-magenta-container__modal-cancelar">
                                        <Button
                                            type="button"
                                            classname="a-button-magenta"
                                            text={"NO, QUIERO REGRESAR"}
                                            isDisabled={false}
                                            onClickAction={() => {
                                                closeCancelForm()
                                            }}
                                            >
                                        </Button>
                                    </div>
                                    <div>
                                    <Button
                                        type="button"
                                        classname="a-button-magenta__cancelar-modal"
                                        text={"SÍ QUIERO"}
                                        isDisabled={false}
                                        onClickAction={() => {
                                            closeForm()
                                        }}
                                        >
                                </Button>
                                    </div>
                                </div>
                        </Modal>
                    )}
                    </FormBody>
                </>
            )}
            {!continueFormMentoriaValidation && (
                <div className="m-modal-container-validation">
                <Modal
                    showModal={true}
                    onClose={closeForm}>
                        <div
                            className={`m-modal-container-validation`}
                        >
                            <h3>¡Ups! Aún no has participado en Mentoría de Talento</h3>
                            <div className="m-modal-container-validation__paragraph">
                                <p>Si ya participaste debes esperar 24 horas para realizar tu registro a la oferta de talleres y cursos.</p>
                            </div>
                            <div className="m-modal-container-validation__paragraph">
                                <p>Recuerda que es necesario asistir a la Mentoría de Talento para acceder a la oferta de aprendizaje, si aún no la has realizado inscríbete para iniciar el proceso.</p>
                            </div>
                            <div className="a-button-magenta-container">
                                <Button
                                    type="button"
                                    classname="a-button-magenta__cancelar"
                                    text={"Cancerlar"}
                                    isDisabled={false}
                                    onClickAction={() => {
                                        closeForm()
                                    }}
                                    >
                                </Button>
                                <Button
                                    type="button"
                                    classname="a-button-magenta"
                                    text={"Inscribirme"}
                                    isDisabled={false}
                                    onClickAction={() => {
                                        closeFormMentoria()
                                    }}
                                    gtmMark="gtmFormClickButtonRegInscripciónMentoría"
                                    data="No ha participado en mentoria (Form aprendizaje Regiones)"
                                    >
                                </Button>
                            </div>
                        </div>
                </Modal>
            </div>
            )}
            {/* Tiene Empleo y no le interesa talleres */}
            {showModalVacancies && (
                <div className="container-modal-courses">
                    <div className="a-modal-continue-courses-left">
                        <div className="a-modal-continue-courses-left">
                            <h1 className="a-modal-continue-courses-left__description">{modalSuccessVacantes.tituloPrincipal}</h1>
                            <span>
                                {rawToReact(modalSuccessVacantes.descripcionFormulario.raw,contentfulRenderOptions)}
                            </span>
                            <div>
                                <Button
                                    type="link"
                                    text={modalSuccessVacantes.tituloBoton}
                                    href={modalSuccessVacantes.redireccionBoton}
                                    isDisabled={false}
                                    classname="a-modal-continue-courses-left__button__white button-left"
                                    gtmMark="gtm_form_click_boton_ver_vacantes_sin_interes_taller"
                                    data="Sin interés (Ruta de aprendizaje)"
                                />
                                <Button
                                    type="link"
                                    text={"CONOCE NUESTROS SERVICIOS"}
                                    href={"https://www.comfama.com/servicio-de-empleo/personas/"}
                                    isDisabled={false}
                                    classname="a-modal-continue-courses-left__button"
                                    gtmMark="gtm_form_click_boton_home_personas_sin_interes_taller"
                                    data="Sin interés (Ruta de aprendizaje)"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="a-modal-continue-courses-right" id="a">
                        <img className="a-modal-continue-courses-right__image" src={modalSuccessVacantes.imagenFormulario.file.url} />
                    </div>
                </div>
            )}
            {showModalCourses && (
                <div className="container-modal-courses">
                    <div className="a-modal-continue-courses-left">
                        <h1 className="a-modal-continue-courses-left__description">{contentfulModalSuccess.tituloPrincipal}</h1>
                        <span>{rawToReact(contentfulModalSuccess.descripcionFormulario.raw,
                            contentfulRenderOptions)}</span>
                        <Button
                            type="link"
                            text={contentfulModalSuccess.tituloBoton}
                            href={contentfulModalSuccess.redireccionBoton}
                            isDisabled={false}
                            classname="a-modal-continue-courses-left__button"
                            gtmMark="gtmFormClickButtonRegInscripciónCursos"
                            data="No tiene talleres Regiones"
                        />
                    </div>
                    <div className="a-modal-continue-courses-right">
                        <img className="a-modal-continue-courses-right__image" src={contentfulModalSuccess.imagenFormulario.file.url} />
                    </div>
                </div>
            )}
            {/* Modal sin Empleo y selecciona un taller */}
            {showModalCourses2 && (
                <div className="container-modal-courses-taller">
                    <h1 className="a-modal-continue-courses__description">{modalSuccessTallerCursos.tituloPrincipal} </h1>
                    <p className="a-modal-continue-courses__description">{rawToReact(modalSuccessTallerCursos.descripcion.raw, contentfulRenderOptions)}</p>
                    <div className="a-modal-continue-courses-taller">
                        <p>Taller Modalidad:  {selectedModality}.</p>
                        <span>{workShop.substring(0, workShop.lastIndexOf(" ")) + " " + duration}</span>
                    </div>
                    <div className="a-modal-continue-courses__aux-text">
                        <p className="a-modal-continue-courses-left__aux-text"><b>{modalSuccessTallerCursos.auxText}</b></p>
                    </div>
                    <div className="a-modal-continue-courses-taller-sugerencia">
                        <img src={iconLila} alt="iconLila" />
                        {/* Lógica para abrir link de subsidio de desempleo en otra pestaña nueva y así no romper el flujo */}
                        {rawToReact(modalSuccessTallerCursos.descripcionFormulario.raw, {
                            ...contentfulRenderOptions,
                            renderNode: {
                                ...contentfulRenderOptions.renderNode,
                                'hyperlink': (node, children) => (
                                    <a href={node.data.uri} target="_blank" rel="noopener noreferrer">
                                        {children}
                                    </a>
                                ),
                            },
                        })}
                    </div>
                    <Button
                        type="link"
                        text={modalSuccessTallerCursos.tituloBoton}
                        href={modalSuccessTallerCursos.redireccionBoton}
                        isDisabled={false}
                        classname="a-modal-continue-courses-left__button"
                        gtmMark="gtmFormClickButtonRegBienvenidaTalleres"
                        data={workShop}
                    />
                </div>
            )}
            {showConInteresConEmpleo && (
                <div className="container-modal-courses">
                    <div className="a-modal-continue-courses-left">
                        <h1 className="a-modal-continue-courses-left__description">{modalContent?.title ? modalContent.title : ""}</h1>
                        <span>{rawToReact(pantallaSinInteresConEmpleo.descripcion.raw,contentfulRenderOptions)}</span>
                        <div className="a-modal-continue-courses-taller">
                            <p>Taller:</p>
                            <span>{workShop.substring(0, workShop.lastIndexOf(" ")) + " " + duration}</span>
                        </div>
                        <Button
                            type="link"
                            text={modalContent?.textButton ? modalContent.textButton : ""}
                            href={modalContent?.url ? modalContent.url : ""}
                            isDisabled={false}
                            classname="a-modal-continue-courses-left__button__white button-left"
                            gtmMark="gtmFormClickButtonRegBienvenidaTalleres"
                            data={workShop}
                        />
                        <Button
                            type="link"
                            text={"CONOCE NUESTROS SERVICIOS"}
                            href={"https://www.comfama.com/servicio-de-empleo/personas/"}
                            isDisabled={false}
                            classname="a-modal-continue-courses-left__button"
                            gtmMark="gtmFormClickButtonRegHomePersonas"
                            data="Sin interés (Ruta de aprendizaje Regiones)"
                        />
                    </div>
                    <div className="a-modal-continue-courses-right" id="a">
                        <img className="a-modal-continue-courses-right__image" src={modalContent?.image ? modalContent.image : ""} />
                    </div>
                </div>
            )}
            {/* Modal sin Empleo y sin interes en Talleres */}
            {showSinInteresSinEmpleo && (
                <div className="container-modal-courses-taller">
                    <h1 className="a-modal-continue-courses__description">{pantallaSinInteresSinEmpleo.tituloPrincipal}</h1>
                    <span className="a-modal-continue-courses-taller-descripcion">
                        {rawToReact(pantallaSinInteresSinEmpleo.descripcion.raw,contentfulRenderOptions)}
                    </span>
                    <div className="a-modal-continue-courses-taller-sugerencia">
                        <img src={iconLila} alt="iconLila" />
                        {/* Lógica para abrir link de subsidio de desempleo en otra pestaña nueva y así no romper el flujo */}
                        {rawToReact(pantallaSinInteresSinEmpleo.descripcionFormulario.raw, {
                            ...contentfulRenderOptions,
                            renderNode: {
                                ...contentfulRenderOptions.renderNode,
                                'hyperlink': (node, children) => (
                                    <a href={node.data.uri} target="_blank" rel="noopener noreferrer">
                                        {children}
                                    </a>
                                ),
                            },
                        })}
                    </div>
                    <Button
                        type="link"
                        text={pantallaSinInteresSinEmpleo.tituloBoton}
                        href={pantallaSinInteresSinEmpleo.redireccionBoton}
                        isDisabled={false}
                        classname="a-modal-continue-courses-left__button"
                    />
                </div>
            )}
            {showModalAlreadyInBoth && (
                <div className="container-modal-courses both">
                    <img src={pantallaRegistroDuplicado.imagenFormulario.file.url} alt="icono alerta modal" />
                    <h1 className="a-modal-continue-courses-left__description">{pantallaRegistroDuplicado.tituloPrincipal}</h1>
                    <span>{rawToReact(pantallaRegistroDuplicado.descripcion.raw,contentfulRenderOptions)}</span>
                    <div className="a-modal-continue-courses-taller__buttons">
                        <Button
                            type="link"
                            text={pantallaRegistroDuplicado.tituloBoton}
                            href={pantallaRegistroDuplicado.redireccionBoton}
                            isDisabled={false}
                            classname="a-button  a-button__magenta "
                        />
                    </div>
                </div>
            )}
            {showModalWithoutAge && (
                <ErrorModal
                    showModal={showModalWithoutAge}
                    onClose={() => setShowModalWithoutAge(false)}
                >
                    <div className={`m-modal-container-validationMpc`}>
                        <img
                            src={contentfulModalWithoutAge.imagenFormulario.file.url}
                            className="o-verification-mpc-response__img"
                            alt="Success"
                        ></img>
                        <h3> {contentfulModalWithoutAge.tituloPrincipal} </h3>
                        <div className="m-modal-container-validationMpc__paragraph">
                            <p>
                                {rawToReact(
                                    contentfulModalWithoutAge.descripcionFormulario.raw,
                                    contentfulRenderOptions
                                )}
                            </p>
                        </div>
                        <Button
                            type="button"
                            classname="a-button__magenta"
                            onClickAction={() => {
                                setShowModalWithoutAge(false)}}
                            isDisabled={false}
                            text={contentfulModalWithoutAge.tituloBoton}
                        />
                    </div>
                </ErrorModal>
            )}
        </div>
    );
};

export default FormTallerAprendizajeRegiones;
